
import ko from 'rgs-knockout';

import { momentViewExtend } from 'ko-extender-view-moment-from-iso';
import {
	localRussianDateViewExtend, localRussianTimeViewExtend,
} from 'ko-extender-view-local-russian-date-from-iso';
import {
	localRussianDateTimeViewExtend,
} from 'ko-extender-view-local-russian-date-time-from-iso';
import {
	moscowRussianDateViewExtend,
} from 'ko-extender-view-moscow-russian-date-from-iso';
import {
	moscowRussianDateTimeViewExtend,
	moscowRussianDateTimeWithSecondsViewExtend,
} from 'ko-extender-view-moscow-russian-date-time-from-iso';
import { reprExtendFromView } from 'ko-utils-repr-from-view';


export const observableISODateExtend = {
	anonymous: observable => observable
		.extend(momentViewExtend)
		.extend(localRussianDateTimeViewExtend)
		.extend(localRussianDateViewExtend)
		.extend(localRussianTimeViewExtend)
		.extend(moscowRussianDateTimeViewExtend)
		.extend(moscowRussianDateViewExtend)
		.extend(moscowRussianDateTimeWithSecondsViewExtend)
		.extend(reprExtendFromView('moment'))
		.extend(reprExtendFromView('moscowRussianDateTime'))
		.extend(reprExtendFromView('moscowRussianDate'))
		.extend(reprExtendFromView('moscowRussianTime'))
		.extend(reprExtendFromView('moscowRussianDateTimeWithSeconds'))
		.extend(reprExtendFromView('localRussianDateTime'))
		.extend(reprExtendFromView('localRussianDate', true)),
};

export function observableISODate (...args) {
	return ko.observable(...args)
		.extend(observableISODateExtend);
}
